module.exports = __webpack_public_path__ + "static/media/01.fbd1d05b.jpg";